/**
 * Responsive candidates for the marketing images vendored under
 * `public/marketing/`.
 *
 * Those files were exported from Webflow keeping its `-p-<width>` variant
 * names, and 24 of them are committed alongside their originals, so the rule
 * here matches what is on disk. It is a near-copy of the adapter's version on
 * purpose: these assets are ours and their naming is now our own convention,
 * so a CMS swap must be able to rewrite the adapter's copy without touching
 * this one. Sharing them would tie the marketing pages to whichever CMS the
 * blog happens to use.
 */
const LADDER = [500, 800, 1080, 1600, 2000, 2600];
const EXTENSION = /^(.*)(\.[A-Za-z0-9]+)$/;

export function localSrcsetFor(path: string, naturalWidth: number): string {
  const parts = EXTENSION.exec(path);
  if (!parts) {
    return "";
  }
  const [, stem, extension] = parts;
  const candidates = LADDER.filter((width) => width < naturalWidth).map(
    (width) => `${stem}-p-${width}${extension.toLowerCase()} ${width}w`
  );
  return candidates.length > 0
    ? [...candidates, `${path} ${naturalWidth}w`].join(", ")
    : "";
}
